import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { restartableTask, task, timeout } from 'ember-concurrency';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';
import { allSettled } from 'rsvp';
import zft from 'garaje/utils/zero-for-tests';

export default class DeliveriesDeliveryAreaGatingModalBillingAdmin extends Component {
  @service flashMessages;

  @tracked selectedAreas = [];
  @tracked searchNeedle = '';
  @tracked nonSelectedAreas = [];
  @tracked showInfo = true;
  @tracked showWarning = false;
  @tracked showSuccess = false;
  @tracked isDisabled = false;

  get filteredAreas() {
    const needle = this.searchNeedle.toLowerCase();
    const areas = [...this.args.activeDeliveryAreas];
    return needle.length > 0 ? areas.filter((area) => area.nameWithLocationName.toLowerCase().includes(needle)) : areas;
  }

  get requiredDeactivations() {
    return this.args.excessCount;
  }

  get areasForDeactivationCount() {
    return Math.max(0, this.requiredDeactivations - this.selectedAreas.length);
  }

  @restartableTask
  *filterByName(name) {
    yield timeout(zft(250));
    this.searchNeedle = name;
  }

  @action
  selectedDidChange(selected) {
    this.isDisabled = false;
    this.nonSelectedAreas = [];
    this.showInfo = true;
    this.showWarning = false;

    if (selected.length >= this.requiredDeactivations) {
      this.showInfo = false;
      this.showSuccess = true;
      this.nonSelectedAreas = this.args.activeDeliveryAreas.filter((a) => !selected.includes(a));
    }

    this.selectedAreas = selected;
  }

  bulkDeactivateAreas = task({ drop: true }, async () => {
    if (this.selectedAreas.length < this.requiredDeactivations) {
      this.isDisabled = true;
      this.showInfo = false;
      this.showWarning = true;
      this.showSuccess = false;
      return;
    }

    this.selectedAreas.forEach((area) => (area.enabled = false));
    await allSettled(this.selectedAreas.map((area) => area.save()));

    const failed = this.selectedAreas.filter((a) => a.isError);
    failed.forEach((a) => a.rollbackAttributes());

    if (failed.length > 0) {
      this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(failed[0].adapterError));
      this.selectedAreas = [];
      this.showInfo = true;
      this.showSuccess = false;
      return;
    }

    this.flashMessages.showAndHideFlash('success', 'Delivery areas deactivated');
    this.args.close();
  });
}
